import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { usePokCore } from '../../../common/hooks/usePokCore';
import {
  EmailPreviewDto,
  GetAttachmentDto,
  ResponseError,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { AttachmentObjectType } from '../../../common/pokCore/validation/enums';

import { EmailPreviewModal } from './EmailPreviewModal';

export const EmailPreviewLink = (props: { emailId: string }) => {
  const pok = usePokCore();
  const notifications = useNotifications();
  const { t, tk } = useTranslation('applicationLng');
  const [showPreview, setShowPreview] = useState(false);
  const [loading, setLoading] = useState(false);
  const [previewData, setPreviewData] = useState<EmailPreviewDto | null>(null);
  const [attachments, setAttachments] = useState<GetAttachmentDto[]>([]);

  const handleClick = async () => {
    setLoading(true);
    try {
      const [preview, emailAttachments] = await Promise.all([
        pok.emails.preview(props.emailId),
        pok.attachments
          .getAllForObject(AttachmentObjectType.SentEmail, props.emailId)
          .catch((error: ResponseError) => {
            notifications.caughtError(error);
            return [] as GetAttachmentDto[];
          }),
      ]);
      setPreviewData(preview);
      setAttachments(emailAttachments);
      setShowPreview(true);
    } catch (error) {
      notifications.caughtError(error as ResponseError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="link"
        className="ms-1"
        onClick={handleClick}
        disabled={loading}
      >
        <OverlayTrigger
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {t(tk.email.preview)}
            </Tooltip>
          }
        >
          <Icon.Eye size={18} />
        </OverlayTrigger>
      </Button>
      {previewData && (
        <EmailPreviewModal
          show={showPreview}
          onHide={() => {
            setShowPreview(false);
            setPreviewData(null);
            setAttachments([]);
          }}
          preview={previewData}
          attachments={attachments}
        />
      )}
    </>
  );
};
